<template>
    <div class="info-wrap">
        <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(updateContactInfo)">
                <h2>Contact Information</h2>
                <p>Enter and Update all your Contact Information here</p>
                <div class="info-form mb-4">            
                    <div class="form-group row">  
                        <div class="col-xxl-3 col-lg-3 col-md-6 mb-3" v-if="contactFormFields.email_address">
                            <ValidationProvider v-slot="{ errors }" :rules="getRules(contactFormFields['email_address'])" :custom-messages="getErrorMessages('email_address')">
                                <label for="email_address">
                                    Email (Must be client's email)
                                    <span v-if="contactFormFields['email_address']['required']" class="required">*</span>
                                </label>
                               <input class="info-field" v-model="contactPostData['email_address']"  id="email_address">
                               <span class="text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>

                <!-- this is to show the validate via otp button when invalid email -->
                                      
                <span v-if="showOtpSectionEmail" class="validate-btn col-md-5 col-sm-6 d-flex ">
                  <a href="#" class="validate-via-otp-link " @click.prevent="openOtpModal('email')" style="color: blue;">
                      Validate via OTP
                  </a>
                </span>



                <!-- this is to show error and success message of email -->
                 
                <div v-if="emailMsg" class="contact-message-container form-group"  style="margin-top: 3px;">
          <div :class="['validate-message', emailValidationMessage.type]">
            <div :class="['message-indicator', `${emailValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${emailValidationMessage.type}-text`">{{ emailValidationMessage.title }}</strong> - 
              {{ emailValidationMessage.message }}
            </span>
          </div>
        </div>
         </div>

    <div class="col-xxl-3 col-lg-3 col-md-6 mb-3" v-if="contactFormFields.phone_number">
     <ValidationProvider v-slot="{ errors }" :rules="getRules(contactFormFields['phone_number'])" :custom-messages="getErrorMessages('phone_number')">
     <label for="phone_number">
       Contact Number
      <span v-if="contactFormFields['phone_number']['required']" class="required">*</span>
     </label>
      <input class="info-field"
          v-model="contactPostData['phone_number']"
          id="phone_number" 
          @input="onPhoneInput"
          inputmode="numeric"
          pattern="\d*">

          <span class="text-danger">{{ errors[0] }}</span>
     </ValidationProvider>
      
                <span v-if="showOtpSectionPhone" class="validate-btn col-md-5 col-sm-6 d-flex ">
                  <a href="#" class="validate-via-otp-link " @click.prevent="openOtpModal('phone')" style="color: blue;">
                      Validate via OTP
                  </a>
                </span>


                <!-- to show the error message dynamically under the fields -->
                <div v-if="phoneMsg" class="contacts-message-container form-group" style="margin-top: 3px;">
          <div :class="['validate-message', phoneValidationMessage.type]">
            <div :class="['message-indicator', `${phoneValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${phoneValidationMessage.type}-text`">{{ phoneValidationMessage.title }}</strong> - 
              {{ phoneValidationMessage.message }}
            </span>
          </div>
        </div>
      </div>
         </div>


                    
                    <div class="form-group row">
                        <div class="col-xxl-3 col-lg-3 col-md-6 mb-3" v-if="contactFormFields.address1">
                            <ValidationProvider v-slot="{ errors }" :rules="getRules(contactFormFields['address1'])" :custom-messages="getErrorMessages('address1')">
                                <label for="address1">
                                    Street Address
                                    <span v-if="contactFormFields['address1']['required']" class="required">*</span>
                                </label>
                               <input class="info-field" v-model="contactPostData['address1']"  id="address1">
                               <span class="text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col-xxl-3 col-lg-3 col-md-6 mb-3" v-if="contactFormFields.address2">
                            <ValidationProvider v-slot="{ errors }" :rules="getRules(contactFormFields['address2'])" :custom-messages="getErrorMessages('address2')">
                                <label for="address2">
                                    Apt/Suite/Other
                                    <span v-if="contactFormFields['address2']['required']" class="required">*</span>
                                </label>
                               <input class="info-field" v-model="contactPostData['address2']"  id="address2">
                               <span class="text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col-xxl-3 col-lg-3 col-md-6 mb-3" v-if="contactFormFields.city">
                            <ValidationProvider v-slot="{ errors }" :rules="getRules(contactFormFields['city'])" :custom-messages="getErrorMessages('city')">
                                <label for="city">
                                    City
                                    <span v-if="contactFormFields['city']['required']" class="required">*</span>
                                </label>
                               <input class="info-field" v-model="contactPostData['city']"  id="city">
                               <span class="text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col-xxl-3 col-lg-3 col-md-6 mb-3" v-if="contactFormFields.state">
                            <ValidationProvider v-slot="{ errors }" :rules="getRules(contactFormFields['state'])" :custom-messages="getErrorMessages('state')">
                                <label for="state">
                                    State
                                    <span v-if="contactFormFields['state']['required']" class="required">*</span>
                                </label>
                                <select class="info-field" id="state" v-model="contactPostData['state']" disabled>
                                    <option v-for="(option, index1) in contactFormFields['state']['options']" :key="index1" :id="option.index1" :value="option.value">
                                        {{ option.name }}
                                    </option>
                                </select>
                               <span class="text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="col-xxl-3 col-lg-3 col-md-6 mb-3" v-if="contactFormFields.zip">
                            <ValidationProvider v-slot="{ errors }" :rules="getRules(contactFormFields['zip'])" :custom-messages="getErrorMessages('zip')">
                                <label for="zip">
                                    Zip code
                                    <span v-if="contactFormFields['zip']['required']" class="required">*</span>
                                </label>
                               <input class="info-field" v-model="contactPostData['zip']"  id="zip" disabled>
                               <span class="text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="form-check col-xxl-6 col-lg-6 col-md-6 mb-3" v-if="contactFormFields.with_validation">
                            <input class="form-check-input" type="checkbox" v-model="contactPostData['with_validation']"  id="with_validation">
                            <label class="form-check-label" for="flexCheckDefault">
                                USPS Address Validation
                            </label>
                        </div>
                    </div>
                    <div class="row justify-content-end mt-3">
                        <div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
                            <button type="submit" class="univ-btn" style=" max-width: 100% !important;">{{ isProcessing ? 'Processing' : 'Update' }}</button>
                        </div>
                    </div>
                </div>
            </form>


        </ValidationObserver>

        
        <EnrollmentOTPModal
    v-if="showOtpModal"
    v-model="showOtpModal"
    :identifier="contactInfo"
    :identifierTypeText="otpType"
    @save="handleVerificationResult"
    @close="closeOtpModal"
    />
    </div>


</template>
<script>
import Api from '@/resource/Api';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import ApiSendOtp from "@/resource/BaseApi";
import EnrollmentOTPModal from '@/views/DownlineRep/Nuera/DownlineOTPNuera.vue';

// import EnrollmentOTPModal from './EnrollmentOTPModaNuera.vue';
/*eslint-disable*/


export default {
    name: 'ContactDetails',
    components: {
        ValidationObserver,
        ValidationProvider,
        EnrollmentOTPModal,
    },
    watch: {
  "contactPostData.phone_number": {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.contactPostData['skip_validation_phone'] = 0;
      }
    },
    immediate: true
  },
  "contactPostData.email_address": {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.contactPostData['skip_validation_email'] = 0;
      }
    },
    immediate: true
  }
},
    data: () => ({
        version: process.env.VUE_APP_API_VERSION,
        isProcessing: false,
        contactPostData: [],
        contactFormFields: [],
        showOtpModal: false,
        showOtpSectionEmail: false,
        showOtpSectionPhone: false,
        emailMsg: false,
        emailValidationMessage: null,
        phoneValidationMessage: null,
        phoneMsg: false,

        
        contactInfo: null,
        otpType: null,
        validationStatus: null,
        emailVerified: false,
        phoneVerified: false,
        skipEmailVerification: false,
        skipPhoneVerification: false,
    }),
    mounted(){
        this.getContactInfo();
    },
    methods: {

    onPhoneInput(event) {
    // Remove all non-digit characters
    let digitsOnly = event.target.value.replace(/\D/g, '');

    // Limit to 10 digits max
    if (digitsOnly.length > 10) {
      digitsOnly = digitsOnly.slice(0, 10);
    }

    // Update the model with cleaned value
    this.contactPostData['phone_number'] = digitsOnly;
  },

    closeOtpModal() {

      this.showOtpModal = false;
    },
     resetValidationState() {
      this.validationStatus = null;
      this.emailValidationMessage = null;
      this.phoneValidationMessage = null;
      this.emailMsg = false;
      this.phoneMsg = false;
      this.showOtpSectionEmail = false;
      this.showOtpSectionPhone = false;
      this.skipEmailVerification = false;
      this.skipPhoneVerification = false;
      this.emailVerified = false;
      this.phoneVerified = false;
    },
    handleVerificationResult(result) {
    if (result.verified) {
      // Handle successful verification
      if (result.type === 'email') {
        this.emailmsg = true;
        this.emailVerified = true;
        this.emailValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Your email has been verified!'
        };
                this.contactPostData['skip_validation_email'] = 1;
        this.showOtpSectionEmail = false;
      } else if (result.type === 'phone') {
        this.phoneMsg = true;
        this.phoneVerified = true;
                this.contactPostData['skip_validation_phone'] = 1;
        this.phoneValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Your phone has been verified!'
        };
        this.showOtpSectionPhone = false;
      }
      this.$notify('Verification successful!');
    } 
    else if (result.skipped) {
      // Handle skipped verification
      if (result.type === 'email') {
        this.skipEmailVerification = true;
        this.contactPostData['skip_validation_email'] = 1;
        this.emailMsg = true;
        this.emailValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Email verification was skipped'
        };
        this.showOtpSectionEmail = false;
      } else if (result.type === 'phone') {
        this.skipPhoneVerification = true;
        this.contactPostData['skip_validation_phone'] = 1;
        this.phoneMsg = true;
        this.phoneValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Phone verification was skipped'
        };
        this.showOtpSectionPhone = false;
      }
      this.$notify('Verification skipped', 'warning');
    }
  },

        // open otp model 

   async     openOtpModal(type) {
      if (type === "email" && !this.contactPostData['email_address']) {
        this.$notify("Please enter an email address first.", "error");
        return;
      }

      if (type === "phone" && !this.contactPostData['phone_number']) {
        this.$notify("Please enter a phone number first.", "error");
        return;
      }
      if(type==="email"){
        this.contactInfo=this.contactPostData['email_address'];
        this.otpType = type;
     this.sendOtp();
      }

      else{
        this.contactInfo=this.contactPostData['phone_number'];
        
        this.otpType = type;
     this.sendOtp();

      }
      this.showOtpModal = true;

      // this.contactInfo = type === "email" ? this.form.email : this.form.cell_phone;
      
    },
    async sendOtp() {

     try {
    const response = await ApiSendOtp.post('api/v2/send-common-otp', {
      contact: this.contactInfo,
      type: this.otpType,
          //  no_attempt_limit: 1,
      expiry_duration: 600,
  
    
    });

    if (response.data.success === true || response.data.status === 'success') {
  this.$notify('OTP sent successfully!');


} 
else {
  this.$notify(response.data.message || 'Failed to send OTP. Please try again.', 'error');


  // this.showOtpSection = false;
}
  } catch (error) {
    this.$notify('Failed to send OTP. Please try again.', 'error');

    // this.showOtpSection = false;
    console.error('OTP send error:', error);
  }
},

        getLabelName(fieldName){
            if(fieldName === 'weight')
                return fieldName.replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) + ' (lbs)'; 
            return fieldName.replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
        },
        getRules(item){
            if(item == null){
                return {};
            }
            if(item.field_name === 'email_address'){
                return {
                    required: item.required,
                    email: true
                }
            }
            if(item.field_name === 'phone_number'){
                return {
                    required: item.required,
                    digits: 10
                }
            }
            if(item.field_name === 'zip'){
                return {
                    required: item.required,
                    digits: 5
                }
            }
            return {required: item.required}
        },
        getErrorMessages(field_name){
            if(field_name === 'zip'){
                return {
                    'required': this.getLabelName(field_name) + " is required",
                    'digits': this.getLabelName(field_name) + " must be 5 digits"    
                }
            }
            if(field_name === 'phone_number'){
                return {
                    'required': "Contact number is required",
                    'alpha': "Contact number may only contain alphabetic characters",
                    'email': "Contact number should be a valid email",
                    'digits': "Contact number must be 10 digits"
                }    
            }
            return {
                'required': this.getLabelName(field_name) + " is required",
                'alpha': this.getLabelName(field_name) + " may only contain alphabetic characters",
                'email': this.getLabelName(field_name) + " should be a valid email",
                'digits': this.getLabelName(field_name) + " must be 10 digits"
            }
        },

        getContactInfo(){
            let url = "v2/rep-24hrs-edit/" + atob(this.$route.params.enrollmentId) + "/contact-info";
            Api.get(url)
                .then((res) => {
                    let contactInfo = res.data.data;
                    contactInfo.map(info => {
                        this.contactPostData = {...this.contactPostData, [info.field_name]: info.value}
                        this.contactFormFields = {...this.contactFormFields, [info.field_name]: info}
                    })
                    this.contactPostData['with_validation'] = 1
                })
                .catch((err) => {
                    Api.notification(err.response.data.success, err.response.data.message)
                })
        },
        updateContactInfo(){
                   this.emailVerified = false;
                    this.phoneVerified = false;
                    this.skipEmailVerification = false;
                    this.skipPhoneVerification = false;
             this.emailValidationMessage = null;
    this.phoneValidationMessage = null;
    this.emailMsg = false;
    this.phoneMsg = false;
    this.showOtpSectionEmail = false;
    this.showOtpSectionPhone = false;
    
            this.isProcessing = true;
            this.contactPostData.with_validation = this.contactPostData.with_validation ? 1 : 0
            Api.patch(`${this.$endpoint.REP_24HRS_EDIT_v3}/${atob(this.$route.params.enrollmentId)}/contact-info`, this.contactPostData)
                .then((response) => {
                    Api.notification(response.data.status, response.data.message);
                        this.contactPostData['skip_validation_email'] = 0;
                         this.contactPostData['skip_validation_phone'] = 0;
                })
  .catch((err) => {

     const errorMsg = err.response?.data?.message;


    // Check for undefined errors
    if (errorMsg.includes("Phone is invalid | Validated using Numverify")) {
        this.$notify("Phone is invalid. Please validate via OTP", "error");
        this.phoneMsg = true;
      
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid phone number, Please validate via OTP.",
          };
          this.showOtpSectionPhone = true;
    }   
    else if (errorMsg.includes("Email is invalid | Validated using Neverbounce")){

        this.$notify("Email is invalid. Please validate via OTP", "error");
        this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid email address, Please validate via OTP.",
          };
          this.showOtpSectionEmail = true;

    

    } else if(errorMsg.includes("Both email and phone are invalid | Validated using Neverbounce and Numverify")) {

        this.$notify("Email and Phone are invalid.", "error");
        this.emailMsg = true;
        this.phoneMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid email address, Please validate via OTP.",
          };
          this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid phone number, Please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
          this.showOtpSectionPhone = true;
    
    } else if(errorMsg.includes("The email address has already been taken")){
        this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The email address is already taken.",
          };
      this.$notify("The email is already taken", "error");
    }
    else if(errorMsg.includes("The phone number has already been taken.")){
        this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Phone number is already taken.",
          };
      this.$notify("The Phone Number is already taken", "error");
    }
    
    
    else if(errorMsg.includes("Address1 is not valid")){
      this.$notify("Invalid address. Please enter a valid address", "error");

     }
     
     else {
        this.$notify(error.response.message, "error");
    }

     }) .finally(()=>{
                    this.isProcessing = false;
                })
        }

    },
}
   
</script>


<style scoped>
input[disabled], select[disabled] {
     background-color:#dce1e7;
}

.form-group {
  margin-bottom: 0.5rem;
}

.validate-message {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0.75rem 1rem;
  position: relative;
  margin-bottom: 0.75rem;
}

.message-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.message-text {
  flex-grow: 1;
  margin-left: 0.5rem;
  color: #495057;
}

.error-text {
  color: #dc3545;
  font-size: 0.875rem !important;
}

.success-text {
  color: #28a745;
}

.warning-text {
  color: #856404;
}

.error-indicator {
  background-color: #dc3545;
}

.success-indicator {
  background-color: #28a745;
}

.warning-indicator {
  background-color: #ffc107;
}

.ai-location-wrapper {
  margin-top: 15px;
}
.ai-location-wrapper label {
  font-size: 16px !important;
  font-weight: bold;
}
.location-div {
  border: 2px solid #dce1e7;
  padding: 10px;
  border-radius: 6px;
}
.location-div p {
  display: inline-block;
  margin-bottom: 0;
}
.location-div button {
  float: right;
  margin-top: 3px;
  padding: 6px 12px;
  margin-right: 35px;
}
.location-div.primary-location {
  border: 2px solid #03c3ec;
}
.location-div.primary-location .primaryAdrs-btn {
  pointer-events: none;
}
.location-div.set-as-primary .primaryAdrs-btn {
  border: 2px solid #03c3ec;
  background-color: #fff;
  color: #03c3ec;
}
.location-div.set-as-primary .primaryAdrs-btn:hover {
  border: 2px solid #03c3ec;
  background-color: #03c3ec;
  color: #fff;
}
.fa-check-circle {
  color: #02bc77;
}
.fa-plus-circle {
  color: #03c3ec;
  font-size: 16px;
  margin-left: 3px;
  vertical-align: revert;
  margin-bottom: 5px;
}
.fa-exclamation-triangle {
  color: #f29423;
}

.location-div {
  position: relative;
}
.location-div .ai-delete-a {
  background: transparent linear-gradient(180deg, #0cf, #1597b8 49%, #0567bc);
  border-radius: 50px;
  width: 27px;
  height: 27px;
  color: #fff;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  margin: 10px 8px;
  position: absolute;
  right: 2px;
  top: 6px;
}
.form-ach .action-icons .primaryAdrs-btn {
  margin-right: 2px;
}
.form-ach .action-icons a {
  margin: 7px;
}
.uploaded {
  width: 100%;
  position: relative;
}
.upload-close-icon {
  max-width: 24px !important;
  max-height: 24px !important;
  position: absolute;
  /* top:1px; */
  margin-left: -14px;
}
</style>